import ACTIONS from 'state/constants';
import CartSelector from 'state/selectors/cart';
import Log from 'utils/Log';

const setCache = cartItems => {
  const cartCache = cartItems.reduce(
    (acc, item) => ({
      ...acc,
      [item.id]: item.price,
    }),
    {}
  );
  try {
    window.localStorage.setItem('cart', JSON.stringify(cartCache));
  } catch (error) {
    Log.warn('Error setting cart cache', error);
  }
};

const setCartCache = store => next => action => {
  next(action);

  if (
    action.type === ACTIONS.SET_CART_CACHE ||
    action.type === ACTIONS.ADD_LINE_ITEMS_SUCCESS ||
    action.type === ACTIONS.UPDATE_LINE_ITEM_SUCCESS ||
    action.type === ACTIONS.REMOVE_LINE_ITEM_SUCCESS ||
    action.type === ACTIONS.CLEAR_CART_SUCCESS
  ) {
    const state = store.getState();
    const cartItems = CartSelector.getCartLineItems(state);
    setCache(cartItems);
  }
};

export default setCartCache;
